import { OrganizationDriverAvailabilitySlot, Frequency } from "../types/availability";
import { mockUsers } from "./mockUsers";

export const mockAvailability: OrganizationDriverAvailabilitySlot[] = [
  // Concurrent on 2025-05-23
  {
    id: "slot-001",
    userId: mockUsers[0].id,
    startTime: "2025-05-23T16:00:00.000Z",
    endTime: "2025-05-23T17:00:00.000Z",
    isRecurring: false,
    createdAt: "2025-05-22T12:00:00.000Z",
    updatedAt: "2025-05-22T12:00:00.000Z",
    recurrence: null,
    user: mockUsers[0],
  },
  {
    id: "slot-002",
    userId: mockUsers[1].id,
    startTime: "2025-05-23T16:30:00.000Z",
    endTime: "2025-05-23T17:30:00.000Z",
    isRecurring: false,
    createdAt: "2025-05-22T12:10:00.000Z",
    updatedAt: "2025-05-22T12:10:00.000Z",
    recurrence: null,
    user: mockUsers[1],
  },
  {
    id: "slot-005",
    userId: mockUsers[3].id,
    startTime: "2025-05-23T16:15:00.000Z",
    endTime: "2025-05-23T17:15:00.000Z",
    isRecurring: false,
    createdAt: "2025-05-22T12:40:00.000Z",
    updatedAt: "2025-05-22T12:40:00.000Z",
    recurrence: null,
    user: mockUsers[3],
  },
  {
    id: "slot-006",
    userId: mockUsers[4].id,
    startTime: "2025-05-23T16:45:00.000Z",
    endTime: "2025-05-23T17:45:00.000Z",
    isRecurring: false,
    createdAt: "2025-05-22T12:45:00.000Z",
    updatedAt: "2025-05-22T12:45:00.000Z",
    recurrence: null,
    user: mockUsers[4],
  },

  // Recurring slots
  {
    id: "slot-003",
    userId: mockUsers[2].id,
    startTime: "2025-05-24T10:00:00.000Z",
    endTime: "2025-05-24T12:00:00.000Z",
    isRecurring: true,
    createdAt: "2025-05-22T12:20:00.000Z",
    updatedAt: "2025-05-22T12:20:00.000Z",
    recurrence: {
      id: "recurrence-001",
      organizationDriverAvailabilitySlotId: "slot-003",
      frequency: Frequency.WEEKLY,
      interval: 1,
      count: null,
      endDate: null,
      createdAt: "2025-05-22T12:20:00.000Z",
      updatedAt: "2025-05-22T12:20:00.000Z",
    },
    user: mockUsers[2],
  },
  {
    id: "slot-004",
    userId: mockUsers[0].id,
    startTime: "2025-05-25T12:00:00.000Z",
    endTime: "2025-05-25T14:00:00.000Z",
    isRecurring: true,
    createdAt: "2025-05-22T12:30:00.000Z",
    updatedAt: "2025-05-22T12:30:00.000Z",
    recurrence: {
      id: "recurrence-002",
      organizationDriverAvailabilitySlotId: "slot-004",
      frequency: Frequency.DAILY,
      interval: 2,
      count: 5,
      endDate: null,
      createdAt: "2025-05-22T12:30:00.000Z",
      updatedAt: "2025-05-22T12:30:00.000Z",
    },
    user: mockUsers[0],
  },
];
